import { icons } from 'assets';
import Button from 'Components/shared/button';
import Text from 'Components/shared/text';
import Tooltip from 'Components/shared/tooltip';
import React from 'react'
import { copyTextToClipboard } from 'utils/stringServices';

import styles from '../wallet.module.css';

const FundingInstruction = ({values,onNext}) => {
    const bankAccount = values.accountNumber;
    const bankName = values.bankName;
    const accountName = values.accountName;
    const remark= values.memo;
    const [copy, setCopy] = React.useState(false);
    

    const copyHandler = () => {
        const onComplete = (err, msg) =>{
            if(err) return;
            setCopy(true);
            setTimeout(() => {
                setCopy(false);
            }, 5000);
        }
        copyTextToClipboard(bankAccount, onComplete);
    }
    
    return(
        <div className={styles.Deposit}>
            <Text variant="lg" style={{fontWeight:"700"}}>
                Transfer {values.amount} to the account details below 
            </Text>
            <Text color="secondary" variant="xs" style={{textAlign:"center", marginTop:"20px"}}>
             Kindly make transfer to the accoount details below. we would reflect
             the payment one recieved on yout wallet. this would take some minutes.
            </Text>
            <Text color="secondary" variant="xs"style={{textAlign:"center",  marginTop:"44px"}} >
                Account
            </Text>
            <Text variant="xl" color="secondary" className="row-start text-center"
            style={{ color:"var(--secondary-color)", fontWeight:800, justifyContent:"center"}}>
                   {bankAccount} 
                <Tooltip open={copy}  onClick={copyHandler} onClose={() => setCopy(false)} title="Copied!">
                    <img style={{marginLeft:"8px", cursor:"pointer"}} src={icons.copyClipboard} 
                   
                    alt="copy to clipboard" />
                </Tooltip>
            </Text>
            <hr style={{marginTop:"17px"}} />
            <AccountDetails name={accountName} bank={bankName} remark={remark} />
            <div className={styles.btnContainer}>
                <Button fullWidth
               
                 onClick={onNext}>I have made the transfer. Continue.</Button>
            </div>
        </div>
    )
}

const AccountDetails = ({name, bank,remark}) => {
    return (
        <div className={styles.AccountDetails}>
            <AccountStructure header="Account name" value={name} />
            <Pipe />
            <AccountStructure header="Bank" value={bank} />
            <Pipe />
            <AccountStructure header="Remark" value={remark} />

        </div>
    )
}
const Pipe = () => {
    return (
        <div style={{height:"52px", width:"2px",
         backgroundColor:"#E2E8F0",borderRadius:"2px"}} ></div>
    )
}
const AccountStructure =({header, value}) => {
    return(
        <div className={styles.AccountStructure}>
            <Text variant="xs" color="secondary" style={{fontSize:"11px", fontWeight:600}}>{header}</Text>
            <Text variant="sm" style={{fontWeight:700}}>{value}</Text>
        </div>
    )
}

export default FundingInstruction;